import React, { useState } from 'react';

const faqs = [
  {
    question: "Bagaimana cara melakukan pemesanan mobil di Vavelle & Co Rental Mobil?",
    answer: "Anda bisa kontak kami via WhatsApp <a href='https://wa.me/6281398253186?text=Halo,%20saya%20tertarik%20untuk%20rental%20mobil'>klik disini</a>."
  },
  {
    question: "Apakah biaya sewa mobil termasuk sopir?",
    answer: "Iya pelayanan kami sudah termasuk sopir"
  },
  {
    question: "Apakah ada pilihan mobil yang bisa dipilih?",
    answer: "Ya anda bisa pilih jenis mobil untuk kebutuhan anda"
  },
  {
    question: "Bagaimana dengan tarif sewa mobil di Vavelle & Co Rental Mobil?",
    answer: "Tarif relatif dari jenis mobil dan durasi pesanannya."
  },
  {
    question: "Apakah armada Vavelle & Co Rental Mobil sudah include AC?",
    answer: "Iya mobil kami dilengkapi dengan AC"
  },
  {
    question: "Apakah armada Vavelle & Co menyediakan jasa antar jemput bandara?",
    answer: "Kami bersedia untuk antar jemput mobil bandara."
  },
  {
    question: "Berapa lama jam sewa mobil wedding?",
    answer: "12 jam maksimum limit sewa mobil wedding. Setelahya akan dikenakan overtime 10% per jam nya"
  },
  {
    question: "Bisakah saya mengajukan pembatalan?",
    answer: "Anda bisa melakukan pembatalan. Bila sudah DP 50%, maka tidak akn ada refund. Bila sudah bayar full di depan, maka refund hanya 50%."
  },
  {
    question: "Bisakah sopir Vavelle & Co Rental Mobil berbahasa asing?",
    answer: "Supir kami bisa berbahasa Inggris."
  },
  {
    question: "Apakah ada opsi rental mobil lepas kunci, tanpa supir?",
    answer: "Saat ini kami tidak menyediakan jasa sewa mobil lepas kunci."
  },
  {
    question: "Apakah ada biaya tambahan yang perlu saya ketahui?",
    answer: "Biaya tambahan tergantung dari kebutuhan anda. Untuk perjalanan keluar kota, akan ada biaya tambahan untuk kebutuhan penginapan dan makanan supir."
  }
];

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (<>
<section className="relative py-16 bg-center" style={{
  backgroundImage: "url('https://images.squarespace-cdn.com/content/v1/659c889624c3267cea6907de/1704758320784-TQVBLXXXFG8SGWA00MAS/FAQ+header.jpg')",
  backgroundSize: 'cover',
  height:'400px'
}}>
  <div className="absolute inset-0 bg-black opacity-50"></div>
  <div className="relative flex items-center justify-center h-full px-4 text-center text-white">
    <div>
      <h1 className="text-3xl font-bold mb-4">FAQ</h1>
      <p className="text-lg">
      Kami adalah perusahaan jasa rental mobil terkemuka yang menawarkan layanan luar biasa dan kendaraan yang andal bagi pelangx`gan kami. Komitmen kami untuk menyediakan pengalaman rental mobil yang bebas hambatan merupakan inti dari semua yang kami lakukan, dan kami bangga memastikan bahwa setiap pelanggan merasa puas.
      </p>
    </div>
  </div>
</section>    
    <div className="max-w-2xl mx-auto my-8">
      {faqs.map((faq, index) => (
        <div key={index} className="mb-4">
          <button
            onClick={() => handleToggle(index)}
            className="w-full p-4 bg-gray-100 text-left text-lg font-semibold flex justify-between items-center focus:outline-none"
          >
            {faq.question}
            <span className={`transform transition-transform ${activeIndex === index ? 'rotate-180' : ''}`}>▼</span>
          </button>
          <div 
            className={`overflow-hidden transition-all duration-500 ease-in-out ${activeIndex === index ? 'max-h-screen p-4 bg-gray-200' : 'max-h-0'}`}
          >
            <p className="text-gray-700" dangerouslySetInnerHTML={{ __html: faq.answer }}></p>
          </div>
        </div>
      ))}
    </div>
    </>
  );
};

export default Faq;